import { CustomHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { IdentifiedFieldIssue } from '../../IFITrackerContext/types'
import { Permission } from 'shared'
import { useRequestIfiSyncMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useGlobalState } from 'context/GlobalStateContext'
import {
  simpleSuccessNotification,
  simpleWarningNotification,
} from 'hooks/notificationHandler'
import { useIFITrackerContext } from '../../IFITrackerContext'
import { useKeyedBooleans } from 'hooks/useKeyedBooleans'
import { errorHandler } from 'hooks/errorHandler'
import { dateFormatter } from '../../../../../../../../../utils/dateFormatter'

export function useCustomHeaderActions(): CustomHeaderActionOptions<IdentifiedFieldIssue>[] {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { refetch } = useIFITrackerContext()
  const [loading, setLoading] = useKeyedBooleans<'sync'>()
  const [sync] = useRequestIfiSyncMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      syncIdentifiedFieldIssues: { lastEditedDate, syncing },
    }) => {
      if (syncing)
        return simpleWarningNotification(
          `Identified Field Issues are already syncing and were requested on ${dateFormatter.datetime(
            lastEditedDate
          )}. Try again later`
        )
      return simpleSuccessNotification(
        `Identified Field Issues successfully synced`
      )
    },
  })
  return [
    {
      type: 'primary',
      text: 'Request Sync',
      permission: Permission.ViewIdentifiedFieldIssue,
      onClick: async () => {
        if (!projectId) return errorHandler('projectId is not defined')
        setLoading.add('sync')
        await sync({ variables: { projectId } })
        setLoading.remove('sync')
        refetch()
      },
      loading: loading('sync'),
      disabled: loading('sync')
        ? { message: 'Please wait for the previous request to finish' }
        : false,
    },
  ]
}
